import React, { Component } from 'react';
import { connect } from 'react-redux';
import InnerPage from '../../shared/InnerPage/InnerPage';
import { ToastContainer, toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import ChallengeStatement from '../../components/ChallengeStatement/ChallengeStatement';
import ChallengeStatementSuccess from '../../components/ChallengeStatement/ChallengeStatementSuccess';
import { getChallengeStatement, createChallengeStatement, editChallengeStatement, resetChallengeStatement } from '../../store/actions/ChallengeStatementActions';

class ChallengeStatementContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
          dataSuccessfulyChanged: false,
          step: 1
        };
    }

    backButton = () =>{
      this.setState({step : 1});
    }

    nextStep = () => {
      this.setState({ step : 2  });
    }

    componentWillReceiveProps(nextProps){
      if(nextProps.editChallengeStatementData.statusCode === 200 && !this.state.dataSuccessfulyChanged && this.state.step === 2){
        this.setState({dataSuccessfulyChanged : true});
        let id = this.props.location.pathname.split('/')[this.props.location.pathname.split('/').length - 1];
        let body = {
          projectId: id,
          type: "challenge"
        }
        this.props.getChallengeStatement(body)
        
      }
    }

    elementInfiniteLoad() {
      return (
          <div className='col-sm-12'>
              <div className='spinner3'>
              <div className='rect1'/>
              <div className='rect2'/>
              <div className='rect3'/>
              <div className='rect4'/>
              <div className='rect5'/>
              </div>
          </div>
      );
    }

    render() {
      return (
        <div>
          <ToastContainer
            position="top-right"
            type="success"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            pauseOnHover
          />
          <InnerPage
            changeUserPassword={this.props.changeUserPassword}
            changePasswordResult={this.props.changePasswordResult}
            location={this.props.location.pathname.split('/')[this.props.location.pathname.split('/').length - 2]}
          >
          { (!this.props.editChallengeStatementFetching && (this.state.step === 1)
          // _.isEmpty(this.props.editChallengeStatementData
            
            )  &&
            <ChallengeStatement
              projectId={this.props.location.pathname.split('/')[this.props.location.pathname.split('/').length - 1]}
              getChallengeStatementData={this.props.getChallengeStatementData}
              createChallengeStatement={this.props.createChallengeStatement}
              editChallengeStatement={this.props.editChallengeStatement}
              getChallengeStatement={this.props.getChallengeStatement}
              nextStep={this.nextStep}
              
            />
          }
          { (this.props.editChallengeStatementFetching || this.props.getChallengeStatementFetching  ) &&
            <div>
              {this.elementInfiniteLoad()}
            </div>
          }
          { (!this.props.editChallengeStatementFetching && !this.props.getChallengeStatementFetching && this.state.dataSuccessfulyChanged && (this.state.step === 2)
            //!_.isEmpty(this.props.editChallengeStatementData) 
          ) && 

            <ChallengeStatementSuccess
              editChallengeStatementData={this.props.editChallengeStatementData}
              getChallengeStatementData={this.props.getChallengeStatementData}
              resetChallengeStatement={this.props.resetChallengeStatement}
              backButton={this.backButton}
              projectId={this.props.location.pathname.split('/')[this.props.location.pathname.split('/').length - 1]}
            />
          }
          
          </InnerPage>
            
        </div>
      );
    }
}

// function loadStyleSheet(url) {
//     let main = document.getElementById('main-style');
//     main.href = url;
// }

function MapStateToProps(state, ownProps) {
  return {
    getChallengeStatementFetching: state.challengeStatement.getChallengeStatementFetching,
    getChallengeStatementData: state.challengeStatement.getChallengeStatementData,
    editChallengeStatementData: state.challengeStatement.editChallengeStatementData,
    editChallengeStatementFetching: state.challengeStatement.editChallengeStatementFetching,
  };
}

const mapDispatchToProps = (dispatch) => ({
  getChallengeStatement: (data) => dispatch(getChallengeStatement(data)),
  createChallengeStatement: (data) => dispatch(createChallengeStatement(data)),
  editChallengeStatement: (data) => dispatch(editChallengeStatement(data)),
  resetChallengeStatement: (data) => dispatch(resetChallengeStatement(data))
  
});

export default withRouter(connect(MapStateToProps, mapDispatchToProps)(ChallengeStatementContainer));



// WEBPACK FOOTER //
// ./src/containers/ChallengeStatement/ChallengeStatementContainer.js